import { render } from "./AdmissionProfile.vue?vue&type=template&id=6cc0bdc0&ts=true"
import script from "./AdmissionProfile.vue?vue&type=script&lang=ts"
export * from "./AdmissionProfile.vue?vue&type=script&lang=ts"

import "./AdmissionProfile.vue?vue&type=style&index=0&id=6cc0bdc0&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__